export default __webpack_public_path__ + "static/media/uploader-dexcom-2.3fd0aa09.png";